export default __webpack_public_path__ + "static/media/source_icon.7a565149.svg";